import Reducer from "./Reducer";
import { combineReducers } from "redux";
import UserReducer from './KSRTC_Redux/userConfig/UserReducer';
import serviceMasterReducer from './KSRTC_Redux/serviceMaster/reducer';
import stockManageReducer from './KSRTC_Redux/stockManage/reducer';
import pprManageReducer from './KSRTC_Redux/PPRManage/reducer';
import MasterReducer from './KSRTC_Redux/MasterConfig/MasterReducer';
import routeMasterReducer from "./KSRTC_Redux/RouteMaster/reducer";
import BookingReducer from "./KSRTC_Redux/bookingPage/bookingReducer";
import ReportsReducer from './KSRTC_Redux/ReportsPage/ReportsReducer'
import OtherReducer from "./KSRTC_Redux/others/OthersReducer"
import TopUpReducer from "./KSRTC_Redux/TopUpPage/TopUpReducer"
import LayoutReducer from "./KSRTC_Redux/layoutMaster/LayoutReducer";
import FareReducer from "./KSRTC_Redux/fareMaster/fareReducer";
import FeedbackReducer from "./KSRTC_Redux/Feedback/feedbackReducer"
import CargoReducer from "./KSRTC_Redux/cargo/CargoReducer";
import CmsReducer from './KSRTC_Redux/cmsPage/cmsReducer';
import CasualContractReducer from './KSRTC_Redux/casualContract/casualContractReducer'
const RootReducer = combineReducers({
  user: Reducer,
  userConfig: UserReducer,
  serviceMasterReducer: serviceMasterReducer,
  stockManageReducer: stockManageReducer,
  pprManageReducer: pprManageReducer,
  masterConfig: MasterReducer,
  routeMasterReducer: routeMasterReducer,
  booking: BookingReducer,
  reportsConfig: ReportsReducer,
  other: OtherReducer,
  topUp: TopUpReducer,
  layoutReducer: LayoutReducer,
  fareMaster: FareReducer,
  feedback: FeedbackReducer,
  cargo: CargoReducer,
  CmsReducer: CmsReducer,
  CasualContractReducer: CasualContractReducer,
});

export default RootReducer;
